module.exports = __webpack_public_path__ + "static/media/002-around.297ca70e.svg";